import { filter } from 'lodash'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import useSWR from 'swr'
import Button from '../components/Button'
import ListRow from '../components/ListRow'
import Loading from '../components/Loading'
import { useUser } from '../hooks'
import { get } from '../lib/fetch'

const Section = ({ lists, header }) => (
  <div className="mb4 mb5-ns">
    <h2 className="f3 fw6 lh-copy mb3 mb4-ns mv0 tracked-light w-100">
      {header}
    </h2>
    {lists.map((list) => (
      <ListRow className="mb4" displayDate key={list.slug} {...list} />
    ))}
  </div>
)

const MyListsPage = () => {
  const [user, { loading }] = useUser(true)
  const Router = useRouter()
  const { data: lists } = useSWR(
    loading ? null : `/api/user/${user.username}/lists`,
    get
  )

  useEffect(() => {
    // redirect user to login if not authenticated
    if (!loading && !user) Router.replace('/login')
  }, [loading, Router, user])

  if (loading || !lists) return <Loading />

  const publishedLists = filter(lists, (list) => list.published_at)
  const draftLists = filter(lists, (list) => !list.published_at)

  const NoLists = () => (
    <h2 className="f3 fw6 lh-copy mb4 mb5-ns mv0 tracked-light w-100">
      No lists yet? Let&apos;s get started
    </h2>
  )

  return (
    <>
      {draftLists.length === 0 && publishedLists.length === 0 && <NoLists />}

      <Link href="/new">
        <a href="new">
          <Button className="mw5-ns mt4 mb4 mb5-ns">Create a new list</Button>
        </a>
      </Link>

      {draftLists.length > 0 && <Section header="Drafts" lists={draftLists} />}
      {publishedLists.length > 0 && (
        <Section header="Published" lists={publishedLists} />
      )}
    </>
  )
}

export default MyListsPage
